import inviewAnim from "./modules/inview";
import Modal from "./modules/Modal";
import setTopSlider from "./modules/setTopSlider";
import { globalNav } from "./modules/libs";
import setAboutSlider from "./modules/setAboutSlider";
import setScrollbarWidth from "./modules/setScrollbarWidth";
import setNotificationClose from "./modules/setNotificationClose";
import setOverviewSlider from "./modules/setOverviewSlider";
import setLocalnavPulldown from "./modules/setLocalnavPulldown";
import setForm from "./modules/setForm";
import setCalendar from "./modules/setCalendar";
import setCalendarBtn from "./modules/setCalendarBtn";
import setHeroVideo from "./modules/setHeroVideo";
import setBnrSlider from "./modules/setBnrSlider";
import setAccessMap from "./modules/setAccessMap";

setScrollbarWidth();

window.addEventListener('load', () => {
  setHeroVideo();
  inviewAnim();
  setAboutSlider();
  setTopSlider();
  globalNav();
  setNotificationClose();
  setOverviewSlider();
  setLocalnavPulldown();
  setForm();
  setCalendar();
  setCalendarBtn();
  setBnrSlider();

  window.modal = new Modal({
    triggerClass: '.js-modal-trigger',
  })

  setAccessMap();
})